module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "resizer",
    class: [type, {
      resizing: resizing
    }],
    on: {
      "mousedown": onMouseDown,
      "mousemove": onMouseMove,
      "mouseleave": onMouseUp,
      "mouseup": onMouseUp
    }
  })
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-b516fa90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resizer.vue
 ** module id = 135
 ** module chunks = 2
 **/